import script from "./grid-color-picker.vue?vue&type=script&setup=true&lang=ts"
export * from "./grid-color-picker.vue?vue&type=script&setup=true&lang=ts"

import "./grid-color-picker.vue?vue&type=style&index=0&id=199607b9&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Cloud Strife\\Desktop\\kronoku-repaint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-199607b9"]])

export default __exports__